import { PrivateKey } from '@shared/services/crypto';
import { RootState } from '../store';
import { createReducer } from '../core';


export type CredentialsState = {
  /** A map of User IDs to associated Credential IDs. */
  credentials: Record<string, string>;
  /** A list of local credentials, used as fallback in platforms where WebAuthn isn't available. */
  privateKeys: PrivateKey[];
};

export function newCredentialsState(): CredentialsState {
  return {
    credentials: {},
    privateKeys: [],
  };
}

export const loadCredentialsSlice = createReducer((state, payload: CredentialsState) => {
  state.credentials = {
    ...newCredentialsState(),
    ...payload,
  }
});

/** Deposit a reference to an external credential ID, e.g. a webauthn key stored on a keychain.  */
export const putExternalCredential = createReducer((state, payload: { userId: string, credentialId: string }) => {
  const { userId, credentialId } = payload;
  state.credentials.credentials[userId] = credentialId;
})

/** Deposit a local private key. */
export const putLocalCredential = createReducer((state, payload: { userId: string, privateKey: PrivateKey }) => {
  const { userId, privateKey } = payload;
  state.credentials.credentials[userId] = privateKey.id;
  state.credentials.privateKeys.push(privateKey);
})

export const selectUserCredentialId = (userId: string) => (state: RootState) => {
  return state.credentials.credentials[userId];
}

export const selectLocalCredential = (userId: string) => (state: RootState) => {
  const credentialId = state.credentials.credentials[userId];
  if (!credentialId) {
    return undefined;
  }
  return state.credentials.privateKeys.find(pk => pk.id === credentialId);
}
